/*  
    global.js -- the hub of all javascripts.  ALL javascripts.  Every. Single. One.
*/
define('global',["core/global/analytics", "core/global/compensatrs", "jquery.unobtrusive-ajax"], function (analytics, compensatr) {
    return {
        init: function() {
            console.log("global");

            analytics.sendToLiveball();
            analytics.trackScrollDepth();
            analytics.sendOrientationToGA();
            analytics.fireDataOnloadOnAnchor();

            compensatr.handleUnsupportedHtml5();
            compensatr.customCSSDetection();
            compensatr.fakePlaceholder();
            compensatr.handleTelLinks();
            compensatr.ie8FontFix();  
        }
    }
});
